import { render, staticRenderFns } from "./TinyMce.vue?vue&type=template&id=1284ec60&"
import script from "./TinyMce.vue?vue&type=script&lang=js&"
export * from "./TinyMce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports